import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { subMonths, subYears, format } from 'date-fns';
import useStatisticDataV4 from '../../../services/statistic-data/hooks/useStatisticV4'; // <-- Menggunakan hook V4
import StatsCardComponent from './StatCardComponent'; // <-- Komponen presentasional yang sama
import StatsCardSkeletonComponent from './StatsCardSkeletonComponent'; // <-- Komponen skeleton yang sama
import { formatPrice } from '../../../shared/utils/formatPrice'; // <-- Asumsi path utilitas format harga

// Interface untuk data yang akan ditampilkan
interface StatsData {
    title: string;
    value: string | number;
    subtitle: string;
    subtitleColor: string;
}

// Interface untuk props komponen
interface StatsCardV4ComponentProps {
    property_id: string;
    start_date: string;
    end_date: string;
}

const StatsCardV4Component: React.FC<StatsCardV4ComponentProps> = ({ property_id, start_date, end_date }) => {
    const [statsData, setStatsData] = useState<StatsData[]>([]);

    // Memanggil hook v4 dengan parameter yang sesuai
    const { data: statisticsData, isFetching } = useStatisticDataV4({
        filters: {
            property_id,
            start_date,
            end_date,
        }
    });

    useEffect(() => {
        if (statisticsData?.data) {
            const now = new Date(start_date); // Menggunakan start_date sebagai referensi bulan ini
            const lastMonth = subMonths(now, 1);
            const lastYear = subYears(now, 1);
            const { data } = statisticsData;

            const payloadStatsData: StatsData[] = [
                {
                    title: "Number Of Reservations (This Month)",
                    value: data.total_booking,
                    subtitle: format(now, "MMMM yyyy"),
                    subtitleColor: "orange",
                },
                {
                    title: "Compared to Last Month",
                    value: data.total_booking_sub_month,
                    subtitle: format(lastMonth, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
                {
                    title: "Compared to Last Year",
                    value: data.total_booking_sub_year,
                    subtitle: format(lastYear, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
                {
                    title: "Total Revenue (This Month)",
                    value: formatPrice(data.total_revenue),
                    subtitle: format(now, "MMMM yyyy"),
                    subtitleColor: "orange",
                },
                {
                    title: "Compared to Last Month",
                    value: formatPrice(data.total_revenue_sub_month),
                    subtitle: format(lastMonth, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
                {
                    title: "Compared to Last Year",
                    value: formatPrice(data.total_revenue_sub_year),
                    subtitle: format(lastYear, "MMMM yyyy"),
                    subtitleColor: "teal",
                },
            ];
            setStatsData(payloadStatsData);
        }
    }, [statisticsData, start_date]);

    return (
        <Row className="stats-cards">
            {isFetching && (
                Array.from({ length: 6 }).map((_, index) => (
                    <Col key={index} md={4}>
                        <StatsCardSkeletonComponent />
                    </Col>
                ))
            )}
            {!isFetching && statsData.map((data, index) => (
                <Col key={index} md={4}>
                    <StatsCardComponent
                        title={data.title}
                        value={data.value}
                        subtitle={data.subtitle}
                        subtitleColor={data.subtitleColor}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default StatsCardV4Component;